import React from 'react';
import './product-attributes-table.scss';
import AttributesInterface from 'interfaces/attributes.interface';

interface ProductAttributesProps {
    slice?: number;
    attributes: AttributesInterface[];
}

const ProductAttributesTable: React.FC<ProductAttributesProps> = props => (
    <div className="product-attributes">
        <table className="attributes-details">
            <tbody>
                {
                    props.attributes.map(item => (
                        <tr className="attributes-details__item" key={item.label}>
                            <td className="attributes-details__item-name">
                                <b>
                                    {item.label}
                                </b>
                            </td>
                            <td className="attributes-details__item-value">
                                {item.value}
                            </td>
                        </tr>
                    ))
                }
            </tbody>
        </table>
    </div>
);

export default ProductAttributesTable;
